import { getPublicRuntimeConfig } from '@watershed/config/utils/publicRuntimeConfig';

export default function isAdminApp(location = window.location) {
  // E.g. localhost:3000 or admin.watershedclimate.com or proxy.localhost:3001
  const adminHost = getPublicRuntimeConfig('NEXT_PUBLIC_ADMIN_HOST');
  if (!adminHost) {
    return false;
  }
  const publicAdminHost = new URL(adminHost);
  return location.host.includes(publicAdminHost.host);
}
